import { SelectedSiteState } from 'src/redesign/features/SelectedSite/types';
import { createSlice } from '@reduxjs/toolkit';
import { FEATURE_NAME } from 'src/redesign/features/SelectedSite/store/constants';
import {
  fetchSiteDataById,
  getSelectedSite,
  updateSiteData,
} from 'src/redesign/features/SelectedSite/store/actions';

const initialState: SelectedSiteState = {
  loading: false,
  error: null,
  siteId: null,
  data: null,
};

export const selectedSiteSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSelectedSite.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getSelectedSite.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getSelectedSite.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(fetchSiteDataById.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.data = action.payload.data;
      state.siteId = action.payload.data.id;
    });
    builder.addCase(fetchSiteDataById.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchSiteDataById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(updateSiteData.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.data = action.payload.data;
    });
    builder.addCase(updateSiteData.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(updateSiteData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});
